import { render, staticRenderFns } from "./ChallengeVoiceGuidance.vue?vue&type=template&id=3ba978d9&scoped=true&"
import script from "./ChallengeVoiceGuidance.vue?vue&type=script&lang=ts&"
export * from "./ChallengeVoiceGuidance.vue?vue&type=script&lang=ts&"
import style0 from "./ChallengeVoiceGuidance.vue?vue&type=style&index=0&id=3ba978d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba978d9",
  null
  
)

export default component.exports